import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Button, Input, TableCell, TableRow, TextField } from "@mui/material";
import * as React from "react";
import { IapSelector } from "../iap";

interface GoldPackEntryProps {
    entry: any;
    classes: any;

    onRemove(item: GoldPackItem);

    onUpdate(item: GoldPackItem);
}

export interface GoldPackItem {
    id: string;
    packageId: string;
    gold: number;
    slotIndex: number;
    googleId: string;
    appleId: string;
    samsungId: string;
    huaweiId: string;
}

export class GoldPackEntry extends React.Component<GoldPackEntryProps, GoldPackItem> {

    constructor(props: GoldPackEntryProps) {
        super(props);

        this.state = {
            id: this.props.entry.id,
            packageId: this.props.entry.packageId,
            gold: this.props.entry.gold,
            slotIndex: this.props.entry.slotIndex,
            googleId: this.props.entry.googleId,
            appleId: this.props.entry.appleId,
            samsungId: this.props.entry.samsungId,
            huaweiId: this.props.entry.huaweiId
        };
    }

    onValueChange = (key: keyof GoldPackItem, value: any) => {
        this.setState(state => {
            let parsedValue = +value;
            if (isNaN(parsedValue)) {
                parsedValue = value;
            }

            // @ts-ignore
            state[key] = parsedValue;

            return state;
        }, () => {
            this.props.onUpdate(this.state);
        });
    };

    onIapChange = (key: keyof GoldPackItem, item) => {
        this.onValueChange(key, item.productId);
    };

    remove = () => {
        if (!confirm("Are you sure you want to delete this Gold Pack?")) {
            return;
        }

        this.props.onRemove(this.state);
    };

    render() {
        return <TableRow
            key={this.state.packageId}
            hover={true}
            className={this.props.classes.tableRow}
        >
            <TableCell>
                <TextField size="small" variant="outlined" value={this.state.packageId}
                       onChange={(e) => this.onValueChange("packageId", e.target.value)}
                       style={{width: "100%"}}/>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" type="number" value={this.state.gold}
                       onChange={(e) => this.onValueChange("gold", e.target.value)}/>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" type="number" value={this.state.slotIndex}
                       onChange={(e) => this.onValueChange("slotIndex", e.target.value)}/>
            </TableCell>
            <TableCell>
                <IapSelector value={this.state.googleId} platform={"ios/android"} label={""}
                             onChange={(_e, item) => this.onIapChange("googleId", item)}/>
            </TableCell>
            <TableCell>
                <IapSelector value={this.state.appleId} platform={"ios/android"} label={""}
                             onChange={(_e, item) => this.onIapChange("appleId", item)}/>
            </TableCell>
            <TableCell>
                <IapSelector value={this.state.samsungId} platform={"udp"} label={""}
                             onChange={(_e, item) => this.onIapChange("samsungId", item)}/>
            </TableCell>
            <TableCell>
                <IapSelector value={this.state.huaweiId} platform={"udp"} label={""}
                             onChange={(_e, item) => this.onIapChange("huaweiId", item)}/>
            </TableCell>
            <TableCell>
                <Button disableElevation onClick={this.remove} size="small">
                    <DeleteForeverIcon color={"error"}/>
                </Button>
            </TableCell>
        </TableRow>;
    }
}
